import CountryPageRenderer from '../components/CountryPageRenderer';
import taiwanData from '../data/country-pages/taiwan';

export default function TaiwanCountryPage() {
  return <CountryPageRenderer data={taiwanData} />;
}
